import { Form, Input, Modal, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { TransformedDataType } from "../../../api/numbers/getSipNumbersData";
import { getSipUserAssignments } from "../../../api/numbers/getSipUserAssignments";
import { getSipOtherAssignments } from "../../../api/numbers/getSipOtherAssignments";
import { getSipMeetingRoomAssignments } from "../../../api/numbers/getSipMeetingRoomAssignments";
import { getSipAssignmentStatuses } from "../../../api/numbers/getSipAssignmentStatuses";
import {
  getLabelFromValue,
  selectOptionsComparator,
  SelectOptionsType,
} from "../../../utils/select-helpers";
import DisplayFieldValues from "../../../components/DisplayFieldValues";
import HeaderContext from "../../../components/layout/header/header-context/HeaderContext";
import { sipStatusChangeLogic } from "../edit-number-status-form-modal/EditNumberStatusFormModalProcessor";
import { putSipNumbers } from "../../../api/numbers/putSipNumbers";
import { getSipStatuses } from "../../../api/numbers/getSipStatuses";

// console.log = ()=>{};

interface Props {
  isVisible: boolean;
  handleClose: (refreshData?: boolean) => void;
  sipNumberRecord?: TransformedDataType;
}

interface State {
  isModalVisible: boolean;
  currentAssignmentStatus: string;
  submitError: string;
  sipAssignmentStatuses?: SelectOptionsType[];
  sipStatusesOptions?: SelectOptionsType[];
  selectedSipStatus: string;
}

const EditNumberAssignmentFormModal: React.FC<Props> = ({
  isVisible,
  handleClose,
  sipNumberRecord,
}) => {
  const [form] = Form.useForm();
  const { currentUserId } = useContext(HeaderContext);
  const [state, setState] = useState<State>({
    isModalVisible: false,
    currentAssignmentStatus: "",
    submitError: "",
    selectedSipStatus: "",
  });

  const {
    currentAssignmentStatus,
    isModalVisible,
    sipAssignmentStatuses,
    sipStatusesOptions,
    submitError,
    selectedSipStatus,
  } = state;

  const handleCancel = () => {
    form.resetFields();
    setState((prevState) => ({
      ...prevState,
      submitError: "",
    }));
    handleClose();
  };

  const handleSubmit = () => {
    setState((prevState) => ({
      ...prevState,
      submitError: "",
    }));
    form
      .validateFields()
      .then((formFields) => {
        console.log("onOk formFields: %o", formFields);
        console.log("sipNumberRecord: %o", sipNumberRecord);
        const payload = {
          id: sipNumberRecord?.id || -1,
          phoneNumber: sipNumberRecord?.phoneNumber || -1,
          poolId: sipNumberRecord?.pool?.id || -1,
          sipStatusName: formFields.sipStatus,
          clientId: currentUserId,
          ...(selectedSipStatus === "Reserved"
            ? { comment: formFields.comment }
            : {}),
        };
        console.log("putSipNumbers() payload: %o", payload);
        putSipNumbers(payload).then((putResponse) => {
          console.log("submitResponse:%o", putResponse);
          if (putResponse?.error) {
            setState((prevState) => ({
              ...prevState,
              submitError: putResponse.error,
            }));
          } else {
            form.resetFields();
            setState((prevState) => ({
              ...prevState,
              submitError: "",
            }));
            handleClose(true);
          }
        });
      })
      .catch((err) => {
        console.log("onOk err: %o", err);
      });
  };

  useEffect(() => {
    if (isVisible !== isModalVisible) {
      setState((prevState) => ({
        ...prevState,
        isModalVisible: isVisible,
        submitError: "",
      }));

      if (!isVisible) return;

      form.setFieldsValue({
        comment: sipNumberRecord?.comment,
      });

      setState((prevState) => ({
        ...prevState,
        selectedSipStatus: sipNumberRecord?.sipStatus.name || "",
      }));

      if (!sipStatusesOptions) {
        getSipStatuses().then((response) => {
          if (response.data) {
            setState((prevState) => ({
              ...prevState,
              sipStatusesOptions: response.data,
            }));
          }
        });
      }

      if (sipNumberRecord?.sipMeetingRoomAssignmentId) {
        console.log("User is %o a MEETING ROOM", sipNumberRecord.id);
        getSipMeetingRoomAssignments(
          sipNumberRecord.sipMeetingRoomAssignmentId.toString()
        ).then((sipMeetingRoomAssignmentResponse) => {
          if (sipMeetingRoomAssignmentResponse.data) {
            const currentAssignmentStatus = getLabelFromValue(
              sipMeetingRoomAssignmentResponse.data.assignmentStatusId,
              sipAssignmentStatuses
            );
            setState((prevState) => ({
              ...prevState,
              currentAssignmentStatus: currentAssignmentStatus,
            }));
          }
        });
      } else if (sipNumberRecord?.sipUserAssignmentId) {
        console.log("User %o is a USER (or VOICE_MAIL)", sipNumberRecord.id);
        getSipUserAssignments(
          sipNumberRecord.sipUserAssignmentId.toString()
        ).then((sipUserAssignmentResponse) => {
          if (sipUserAssignmentResponse.data) {
            const currentAssignmentStatus = getLabelFromValue(
              sipUserAssignmentResponse.data.assignmentStatusId,
              sipAssignmentStatuses
            );
            setState((prevState) => ({
              ...prevState,
              currentAssignmentStatus: currentAssignmentStatus,
            }));
          }
        });
      } else if (sipNumberRecord?.sipOtherAssignmentId) {
        console.log("User %o is OTHER", sipNumberRecord.id);
        getSipOtherAssignments(
          sipNumberRecord.sipOtherAssignmentId.toString()
        ).then((sipOtherAssignmentResponse) => {
          if (sipOtherAssignmentResponse.data) {
            const currentAssignmentStatus = getLabelFromValue(
              sipOtherAssignmentResponse.data.assignmentStatusId,
              sipAssignmentStatuses
            );
            setState((prevState) => ({
              ...prevState,
              currentAssignmentStatus: currentAssignmentStatus,
            }));
          }
        });
      } else {
        console.error(
          "Bad Data: User is a neither a MEETING-ROOM nor USER nor VOICE_MAIL nor OTHER"
        );
        const currentAssignmentStatus = "Unassigned";
        setState((prevState) => ({
          ...prevState,
          currentAssignmentStatus: currentAssignmentStatus,
        }));
      }
      console.log(
        "<EditNumberAssignmentFormModal/> sipNumberRecord: %o",
        sipNumberRecord
      );
    }

    // eslint-disable-next-line
  }, [isVisible, isModalVisible]);

  useEffect(() => {
    getSipAssignmentStatuses().then((sipAssignmentStatusesResponse) => {
      setState((prevState) => ({
        ...prevState,
        sipAssignmentStatuses: sipAssignmentStatusesResponse.data,
      }));
    });
  }, []);

  //Edit under Assignment column
  return (
    <Modal
      title="Update Phone Number Status"
      maskClosable={false}
      open={isModalVisible}
      onCancel={handleCancel}
      cancelText="Cancel"
      okText="Submit"
      onOk={handleSubmit}
      okButtonProps={{
        className: "bdo-red-button-modal",
      }}
      cancelButtonProps={{
        className: "bdo-grey-button-modal",
      }}
    >
      <DisplayFieldValues
        labelValues={[
          {
            label: "Phone Number",
            value: `${sipNumberRecord?.phoneNumberX}`,
          },
          {
            label: "Type",
            value: `${sipNumberRecord?.type}`,
          },
          {
            label: "Username",
            value: `${sipNumberRecord?.username}`,
          },
          {
            label: "Assignment Status",
            value: `${currentAssignmentStatus}`,
            // getSipAssignmentStatuses(getSipUserAssignments       (sipNumberRecord.sipUserAssignmentId)       .assignmentStatusId).name
            // OR
            // getSipAssignmentStatuses(getSipMeetingRoomAssignments(sipNumberRecord.sipMeetingRoomAssignmentId).assignmentStatusId).name
            // OR
            // getSipAssignmentStatuses(getSipOtherAssignments      (sipNumberRecord.sipOtherAssignmentId)      .assignmentStatusId).name
          },
          {
            label: "Phone Number Status",
            value: `${sipNumberRecord?.sipStatus.name}`,
          },
          ...(sipNumberRecord?.comment
            ? [{ label: "Comment", value: `${sipNumberRecord?.comment}` }]
            : []),
        ]}
      />

      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
        <Form.Item
          name="sipStatus"
          label={"Update Status:"}
          rules={[{ required: true, message: "This field is required" }]}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <Select
            placeholder="Select a SIP status"
            onChange={(selectedLabel) => {
              setState((prevState) => ({
                ...prevState,
                selectedSipStatus: selectedLabel,
              }));
            }}
            allowClear
            options={[
              ...sipStatusChangeLogic[
                sipNumberRecord?.sipStatus.name || ""
              ]?.map((status) => ({ title: "", label: status, value: status })),
            ].sort(selectOptionsComparator)}
          ></Select>
        </Form.Item>

        {selectedSipStatus === "Reserved" && (
          <Form.Item
            name="comment"
            label="Comment:"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        )}
      </Form>

      {submitError && <div className="text-red-500">{submitError}</div>}
    </Modal>
  );
};

export default EditNumberAssignmentFormModal;
